export enum IssueStatus {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  POSTPONED = 'POSTPONED',
}

export interface IssueItem {
  id?: string | number;
  description: string;
  projectIds?: string[];
  status?: IssueStatus;
  createdAt?: string;
  updatedAt?: string | null;
  closedDate?: string | null;
  retentionRiskId?: string | null;
  isNew?: boolean;
  [key: string]: unknown;
}

interface IssuesModalCallbacks {
  onSubmit: (
    issues: Partial<IssueItem>[],
    data: {
      issues: Partial<IssueItem>[];
      isClosedIssuesPostponed: boolean;
      postponeInformation: Record<string, unknown> | null;
      targetZone?: string;
    },
  ) => void | Promise<void>;
  onClose: () => void;
}

interface IssuesModalConfig {
  postponeOptions?: Record<string, string>;
  postponeOptionsObjects?: Record<string, Record<string, unknown>>;
  statusField?: string;
  closedStatus?: string;
}

export interface IssuesModalProps {
  isOpen: boolean;
  data?: IssueItem[] | { employeeData?: { retentionRiskIssues?: IssueItem[] } } | Record<string, unknown>;
  onClose: () => void;
  globalData?: Record<string, unknown>;
  getDataFunc?: () => Record<string, unknown>;
  submitFormFunc?: (data: Record<string, unknown>) => void | Promise<void>;
  getValidationSchemaFunc?: () => Record<string, unknown>;
  afterSubmit?: { execute: () => void };
  callbacks?: IssuesModalCallbacks;
  config?: IssuesModalConfig;
}
